<div class="grid flex">
    @for (news of newsItems$ | async; track $index) {
        <div class="flex">
            @if (variant() === 'release') {
                <riege-release-report class="flex" [data]="news"></riege-release-report>
            } @else {
                <riege-card class="card--news flex" [data]="news"></riege-card>
            }
        </div>
    }
</div>
